<template>
  <div class="modal_card">
    <div class="modal_form mail_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1 style="text-align: center; margin-top: 20px;">
        На указанную Вами почту было выслано <br />
        сообщение с дальнейшими действиями.
      </h1>
      <div>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Закрыть</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
